import React from 'react';
import classNames from 'classnames';
import css from './styles.module.scss';
import { Box, Typography } from '@material-ui/core';
import { BoxProps } from '@material-ui/core/Box/Box';
import { VerticalPopver } from '~/features/dashboard/components/vertical-popover';

type PageBlockProps = BoxProps & {
    editActionComponent?: JSX.Element;
    titleComponent?: JSX.Element;
    editAction?(): void;
};

export const PageBlock: React.FC<PageBlockProps> = ({
    className,
    editAction,
    editActionComponent,
    titleComponent,
    title,
    children,
    ...props
}) => {
    return (
        <Box className={classNames(css.module, className)} {...props}>
            {(title || titleComponent) && (
                <Box className={css.moduleTitle}>
                    {titleComponent || (
                        <Typography className="typography gray bold h4Head" variant="h4">
                            {title?.toUpperCase()}
                        </Typography>
                    )}
                    {(editActionComponent || editAction) && (
                        <Box>
                            {editActionComponent}
                            {editAction && (
                                <VerticalPopver childClassName={css.editIcon} actionsList="edit" onClickEdit={editAction} />
                            )}
                        </Box>
                    )}
                </Box>
            )}
            <Box className={css.moduleContent}>
                {children}
            </Box>
        </Box>
    );
};
